"use client";
import { isMotionValue } from "motion-dom";
import { Fragment, createElement, useMemo } from "react";
import { useHTMLProps } from "../html/use-props";
import { useSVGProps } from "../svg/use-props";
import { filterProps } from "./utils/filter-props";
import { isSVGComponent } from "./utils/is-svg-component";
export function useRender(Component, props, ref, { latestValues, }, isStatic, forwardMotionProps = false, isSVG) {
    const useVisualProps = (isSVG ?? isSVGComponent(Component)) ? useSVGProps : useHTMLProps;
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== Fragment ? { ...filteredProps, ...visualProps, ref } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */
    const { children } = props;
    const renderedChildren = useMemo(() => (isMotionValue(children) ? children.get() : children), [children]);
    return createElement(Component, {
        ...elementProps,
        children: renderedChildren,
    });
}
//# sourceMappingURL=use-render.js.map